import { type ReactNode } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface SplitViewProps {
  left: ReactNode;
  right?: ReactNode;
  className?: string;
  leftClassName?: string;
}

export function SplitView({ left, right, className, leftClassName }: SplitViewProps) {
  return (
    <div className={cn("flex", className)}>
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
        className={cn(
          "flex-shrink-0 border-r border-border/40 sticky top-[54px] self-start h-[calc(100vh-54px)]",
          right ? "w-1/3" : "w-full",
          leftClassName
        )}
      >
        {left}
      </motion.div>
      {right && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="flex-1"
        >
          {right}
        </motion.div>
      )}
    </div>
  );
}

